export default {
    common: {
        title: "Editar imagen",
        cancel: "Cancelar",
        save: "Guardar",
        crop: "Cosecha",
        adjustments: "Ajustes",
        filters: "Filtros",
        frames: "Marcos",
        overlays: "superposiciones",
        text: "Texto",
        stickers: "Pegatinas",
        brush: "Cepillo",
        ai: "Crear imagen utilizando IA",
        reset: "Restablecer",
        comingSoon: 'Próximamente...',
    },
};
